import { render, staticRenderFns } from "./Performance.vue?vue&type=template&id=f61e54ca&scoped=true&"
import script from "./Performance.vue?vue&type=script&lang=js&"
export * from "./Performance.vue?vue&type=script&lang=js&"
import style0 from "./Performance.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Performance.vue?vue&type=style&index=1&id=f61e54ca&lang=scss&scoped=true&"
import style2 from "./Performance.vue?vue&type=style&index=2&id=f61e54ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61e54ca",
  null
  
)

export default component.exports